import { forwardRef } from 'react';
import PropTypes from 'prop-types';

export const IconGroupItem = forwardRef(({ width, height, className, fill }, ref) => {
		return (
			<svg
				ref={ref}
				width={width}
				height={height}
				className={className}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 36.77 36.77">
				<path
					d="M0,0H21a5,5,0,0,1,5,5V26H5a5,5,0,0,1-5-5Z"
					transform="translate(18.385 36.77) rotate(-135)"
					fill={fill}
				/>
			</svg>
		);
	}
);

IconGroupItem.propTypes = {
	fill: PropTypes.string,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

IconGroupItem.defaultProps = {
	fill: '#B3997D',
	width: '36.77',
	height: '36.77'
};

IconGroupItem.displayName = 'IconGroupItem';
